<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="查看详情"></el-page-header>
        <div>
            <el-steps :active="active" finish-status="success" align-center>
                <el-step title="待付款" :description="item.time"></el-step>
                <el-step title="待发货" :description="item.time"></el-step>
                <el-step title="待收货" :description="item.time"></el-step>
                <el-step title="已完成" :description="item.time"></el-step>
            </el-steps>
        </div>
        <div class="detail">
            <div style="height: 250px">
                <p><em>订单编号：</em><span>{{item.orderSn}}</span></p>
                <p><em>付款方式：</em><span>{{item.payment}}</span></p>
                <p><em>配送方式：</em><span>{{item.shipment}}</span></p>
                <p><em>收货人：</em><span class="color-blue">{{item.consignee}}</span></p>
                <p><em>买家手机：</em><span>{{item.mobile}}</span>
                    <span class="color-blue copy-text" :data-clipboard-text="item.mobile"
                          style="margin-left: 20px;cursor: pointer;" @click="copy">复制</span></p>
                <p><em>收货地址：</em><span class="color-blue">{{item.address}}</span><span class="color-blue copy-text"
                                                                                       :data-clipboard-text="item.address"
                                                                                       style="margin-left: 20px;cursor: pointer;"
                                                                                       @click="copy">复制</span></p>
            </div>
            <div style="height: 250px" class="indent-type">
                <p>订单状态：
                    <span class="color-waring" v-if="item.order_status == 1">待付款</span>
                    <span class="color-waring" v-else-if="item.order_status == 2">待发货</span>
                    <span class="color-waring" v-else-if="item.order_status == 3">待收货</span>
                    <span class="color-waring" v-else-if="item.order_status == 4">已完成</span>
                    <span class="color-waring" v-else-if="item.order_status == 5">用户取消</span>
                    <span class="color-waring" v-else-if="item.order_status == 6">系统取消</span>
                    <span class="color-waring" v-else>退款申请中</span>
                </p>
                <p class="tips" v-if="item.order_status == 2">友情提醒：如果无法发货，请与买家联系</p>
            </div>
            <div class="distribution" style="display: none;">
                <span class="title">一级分销商</span>
                <p><em>姓名：</em><span class="color-blue">小半</span></p>
                <p><em>手机号：</em><span>13102.3</span></p>
                <p><em>佣金：</em><span>4861231</span></p>
            </div>
        </div>
        <div class="list-box-content">
            <div class="list">
                <div class="list-title">
                    <span>订单号</span>
                    <span>买家</span>
                    <span>卖家店铺</span>
                    <span>订单金额</span>
                    <span>供应金额</span>
                    <span>支付方式</span>
                </div>
                <div class="list-content-box">
                    <div class="list-content">
                        <div>
                            <span>{{item.order_sn}}</span>
                        </div>
                        <div>
                            <span>{{item.buyer ? item.buyer.nick_name : ''}}</span>
                        </div>
                        <div>
                            <span>{{item.store ? item.store.name : ''}}</span>
                        </div>
                        <div>
                            <span>订单总额:￥{{item.order_price}}</span>
                            <span>运费金额:￥{{item.freight_price}}</span>
                            <span>实付款金额:<span class="x-color-red">￥{{item.actual_price}}</span></span>
                        </div>
                        <div>
                            <span>供应总额:￥{{item.supplier_total_price}}</span>
                            <span>运费金额:￥{{item.freight_price}}</span>
                            <span>实结算金额:<span class="x-color-red">￥{{parseFloat(item.supplier_total_price) + parseFloat(item.freight_price)}}</span></span>
                        </div>
                        <div>
                            <el-tag :class="item.pay_type == 1 ? 'info' : ''">{{item.pay_type == 1 ? '微信支付' : '积分支付'}}
                            </el-tag>
                        </div>
                    </div>

                </div>
                <div class="list-booton">
                    <span>商品小计 </span>&nbsp;￥{{item.order_price}}&nbsp;元&nbsp;
                </div>
            </div>
        </div>
        <div class="list-box-content">
            <div class="list">
                <div class="list-title">
                    <span>商品标题</span>
                    <span>规格、编号、条码</span>
                    <span>供应价</span>
                    <span>数量</span>
                    <span>实付金额</span>
                    <span>创建时间</span>
                    <span>操作</span>
                </div>
                <div class="list-content-box">
                    <div class="list-content" v-for="attr in item.goods">
                        <div class="thumb">
                            <img :src="attr.pic_url" width="70px" height="70px" style="height: 70px">
                            <div class="goods-text">
                                <span>{{attr.product_name}}</span>
                            </div>
                        </div>
                        <div class="sku-style">
                            <div>
                                <span><em>规格：</em><span class="sku-detail">{{attr.sku_name}}</span></span>
                            </div>
                        </div>
                        <div>
                            <span>￥{{attr.cost_price}}</span>
                        </div>
                        <div>
                            <span>{{attr.number}}个</span>
                        </div>
                        <div>
                            <span>{{attr.supplier_total_price}}</span>
                        </div>
                        <div>
                            <span>{{attr.created_date}}</span>
                        </div>
                        <div>
                            <el-button style="margin-left: 10px;" size="mini" type="primary" @click="changePrice(attr)">
                                修改商品金额
                            </el-button>
                        </div>
                    </div>

                </div>
                <div class="list-booton">
                    <span>商品小计 </span>&nbsp;￥{{item.order_price}}&nbsp;元&nbsp;
                </div>
            </div>
        </div>
        <div class="list-box-content" v-if="item.delivery_status == 1">
            <div class="list">
                <div class="list-title">
                    <span>物流公司</span>
                    <span>物流单号</span>
                    <span>发货状态</span>
                    <span>发货时间</span>
                </div>
                <div class="list-content-box">
                    <div class="list-content">
                        <div>
                            <span>{{item.express_company}}</span>
                        </div>
                        <div>
                            <span>{{item.express_sn}}<el-button class="ml20" type="info" size="small"
                                                                @click="openLogistics">物流查询</el-button></span>
                        </div>
                        <div>
                            <span>已发货</span>
                        </div>
                        <div>
                            <span>{{item.delivery_time}}</span>
                        </div>
                    </div>

                </div>
                <div class="list-booton">
                    <span>商品小计 </span>&nbsp;￥{{item.order_price}}&nbsp;元&nbsp;
                </div>
            </div>
        </div>
        <div id="cancel" style="margin-top: 20px" v-if="item.order_status == 21">
            <el-form label-position="right" label-width="auto">
                <el-form-item label="审核状态">
                    <el-popconfirm title="您确定要通过这条数据吗？" @confirm="agree">
                        <el-button size="big" type="primary" slot="reference">通过</el-button>
                    </el-popconfirm>
                    <el-button size="big" type="danger" @click="refuse" class="l10" style="margin-left: 10px">拒绝
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <template v-if="orderGoods">
            <el-dialog title="修改价格" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
                <div>
                    <div style="margin-bottom: 8px">商品名称：{{orderGoods.product_name}}{{orderGoods.sku_name}}</div>
                    <div style="margin-bottom: 8px">商品规格：{{orderGoods.sku_name}}</div>
                    <div style="margin-bottom: 8px">供应单价：{{orderGoods.cost_price}}</div>
                    <div style="margin-bottom: 8px">商品数量：{{orderGoods.number}}</div>
                    <div style="margin-bottom: 8px">商品总额：{{orderGoods.supplier_total_price}}</div>
                    <div style="display: flex;align-items: center;margin-top: 20px;">
                        <span style="flex-shrink: 0;margin-right: 10px;">供应调整金额(元)</span>
                        <el-input v-model="newPrice" placeholder="金额" style="flex-grow: 1;"></el-input>
                    </div>
                    <div style="color: #666;margin-top: 20px">实际商品金额 = 商品总额 + 调价</div>
                </div>
                <span slot="footer" class="dialog-footer">
					<el-button type="" @click="handleClose">取消</el-button>
					<el-button type="primary" @click="sureSub">确 定</el-button>
				</span>
            </el-dialog>
        </template>
        <el-dialog :visible.sync="modal2" v-if="item.pay_status == 1 && item.delivery_status == 1" scrollable
                   title="物流查询" width="350" class="order_box2">
            <div class="logistics acea-row row-top">
                <div class="logistics_img"><img src="@/assets/images/expressi.jpg"></div>
                <div class="logistics_cent">
                    <span>物流公司：{{item.express_company}}</span>
                    <span class="ml20">物流单号：{{item.express_sn}}</span>
                </div>
            </div>
            <div class="acea-row row-column-around trees-coadd mt50">
                <div class="scollhide">
                    <el-timeline :reverse="reverse">
                        <el-timeline-item
                                v-for="(item,i) in result"
                                :key="index"
                                :timestamp="item.time">
                            {{item.context}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import Clipboard from 'clipboard'

    export default {
        data() {
            return {
                item: {},
                isLoad: false,
                id: this.$route.query.id,
                list: {},
                totalFee: 0,
                active: 0,
                orderGoods: false,
                newPrice: 0,
                modal2: false,
                result: []
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            loadData: function () {
                this.axios.get('/supplier/order/detail', {
                    params: {
                        id: this.id
                    }
                })
                    .then(res => {
                        this.item = res.data.detail
                        if (this.item.order_status <= 4) {
                            this.active = this.item.order_status
                        } else {
                            this.active = 0
                        }

                        this.item.goods.forEach(res => {
                            this.totalFee += res.totalFee
                        })
                    })
            },
            copy() {
                var clipboard = new Clipboard('.copy-text')
                clipboard.on('success', e => {
                    this.$message.success({
                        message: '复制成功',
                        showClose: false
                    });
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    this.$message.danger({
                        message: '该浏览器不支持自动复制',
                        showClose: false
                    });
                    // 释放内存
                    clipboard.destroy()
                })
            },
            openLogistics: function () {
                this.axios.post('/supplier/order/express', {
                    id: this.id
                }).then((res) => {
                    if (res.code == 1) {
                        this.result = res.data.express.list;
                        this.modal2 = true
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(() => {
                    this.isLoad = false
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            send(id, name) {
                this.$router.push({
                    path: '/Indent/send.html',
                    query: {
                        id: id,
                        name: name
                    }
                });
            },
            agree: function () {
                this.axios.post('/supplier/order/confirmcancel', {
                    id: this.id,
                    order: {
                        is_cancel: 1
                    }
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '审核成功'
                    });
                    this.goBack()
                }).catch(() => {
                    this.isLoad = false
                })
            },
            refuse: function () {
                this.$prompt('', '拒绝原因', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    if (value == '') {
                        this.$message.success({
                            message: '请输入拒绝原因'
                        });
                        return
                    }
                    if (this.isLoad) {
                        return
                    }
                    this.isLoad = !this.isLoad
                    this.axios.post('/supplier/order/confirmcancel', {
                        id: this.id,
                        order: {
                            memo: value,
                            is_cancel: 0
                        }

                    })
                        .then(() => {
                            this.isLoad = false
                            this.$message.success({
                                message: '审核成功'
                            });
                            this.goBack()
                        })
                        .catch(() => {
                            this.isLoad = false
                        })
                }).catch(() => {

                });
            },
            changePrice: function (row) {
                this.dialogVisible = true
                this.orderGoods = row
                this.newPrice = row.supplier_adjust_money
            },
            handleClose() {
                this.dialogVisible = false
                this.orderGoods = false
            },
            sureSub() {
                this.axios.post('/supplier/order/changeGoodsAdjustPrice', {
                    id: this.orderGoods.id,
                    supplier_adjust_money: this.newPrice,
                })
                    .then(() => {
                        this.newPrice = ''
                        this.$message.success({
                            message: '操作成功'
                        });
                        this.loadData()
                        this.dialogVisible = false
                    })
                    .catch(() => {
                        this.price = ''
                        this.selectStoreCategory = ''
                    })
            },
        }
    }
</script>
<style scoped>
    .detail {
        width: 100%;
        margin-top: 30px;
        display: flex;
        flex-wrap: nowrap;
    }

    .detail > div {
        width: 1px;
        height: 520px;
        flex-grow: 1;
        padding-top: 50px;
        padding-left: 30px;
        box-sizing: border-box;
        border: 1px solid #eeeeee;
        position: relative;
    }

    .detail div p {
        font-size: 16px;
        line-height: 2;
        color: #a5a5a5;
    }

    .detail p em {
        font-style: normal;
        display: inline-block;
        width: 80px;
    }

    .detail div span {
        color: #000000
    }

    .detail .color-blue {
        color: #2ca5f8;
    }

    .detail .color-green {
        color: #49c747;
        font-size: 24px;
    }

    .detail .color-waring {
        color: rgb(255, 192, 0);
        font-size: 24px;
    }

    .distribution em {
        width: 60px !important;
    }

    .detail .indent-type {
        display: flex;
        flex-direction: column;
    }

    .detail .tips {
        position: absolute;
        bottom: 200px
    }

    .distribution .title {
        display: inline-block;
        font-weight: bold;
        margin-bottom: 10px;

    }


    .list-box-content {
        width: 100%;
        border: 1px solid #a1a1a1;
        margin-top: 40px;
    }

    .list-box-content .list {
        width: 100%;
    }

    .list .list-title {
        width: 100%;
        height: 64px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #bfbfbf;
    }

    .list-title span {
        width: 1px;
        flex-grow: 1;
        display: flex;
        justify-content: center;
    }

    .list-title span:first-child {
        justify-content: flex-start !important;
        text-indent: 40px;
    }

    .list .list-content-box {
        border-bottom: 1px solid #bfbfbf;
    }

    .list-content-box .list-content {
        /* width: 100%; */
        display: flex;
        flex-wrap: nowrap;
        height: 120px;
        align-items: center;
    }

    .list-content > div {
        width: 1px;
        height: 120px;
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-left: 1px solid #bfbfbf;
    }

    .list-content span {
        line-height: 1.5;
    }

    .thumb {
        display: flex;
        flex-direction: row !important;
        border-left: none !important;
    }

    .goods-text {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
    }

    .sku-style span {
        display: flex;
        align-items: center;
        line-height: 2;
    }

    .sku-style em {
        font-style: normal;
    }

    .sku-style .sku-detail {
        padding: 0 10px;
        background-color: rgb(68, 171, 247);
        color: #FFFFFF;
        border-radius: 4px;
    }

    .list .list-booton {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .send {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>
